import { PassThrough } from '@primevue/core'
import { PrimeVuePTOptions } from 'primevue'

// @unocss-include
export default {
  confirmdialog: {
    pcRejectButton: {
      root: {
        class: 'p-button-outlined',
      },
    },
  },
  card: {
    caption: {
      class: 'gap-0',
    },
    title: {
      class: '!text-lg',
    },
    subtitle: {
      class: '!text-sm',
    },
  },
  step: {
    root: {
      style: {
        'margin-top': '-1rem',
      },
    },
    header: {
      style: {
        'margin-top': '1rem',
        'flex-direction': 'column',
        'row-gap': '0',
      },
    },
  },
  selectButton: {
    root: {
      class: 'rounded-full',
    },
  },
  tab: {
    root: {
      style: {
        'font-family': '"Montserrat Variable", sans-serif',
      },
    },
  },
} as PassThrough<PrimeVuePTOptions>